import React from "react";
import ReactLoading from "react-loading";

const Loading = () => <ReactLoading color="#acacac" />;

export default Loading;
